import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { SITENAMEALIAS, DEMOBROKER } from "../utils/init";
import Loader from "../components/Loader";
import { showToast, showHttpError } from "../utils/library";
import { updateFavicon } from "../utils/favicon";
import {
  getRegister,
  getSignUpEmailOtp,
  getSignUpPhoneOtp,
} from "../utils/service";
import logo from "../assets/images/paybitologo.png";
import { Helmet } from "react-helmet";

class Otp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      verifySignUpBtn: true,
      showLoader: false,
      emailOtpTimer: "",
      phoneOtpTimer: "",
      resendEmailOtpBtn: false,
      resendPhoneOtpBtn: false,
      secondStatusCheckForEmailOtp: false,
      secondStatusCheckForPhoneOtp: false,
      isTwoMinTimerStart: false,
      twoMinTimerTxt: "",
      secondStatusCheckForTwoMinTimer: false,
      emailVerificationOtp: "",
      isEmailOtpCorrect: false,
      isPhoneOtpCorrect: false,
      isHideResendOtpBtn: false,
      isResendTimerStartForEmailOtp: false,
      isResendTimerStartForPhoneOtp: false,
      lastSubmittedOtp: "",
    };
    this.emailOtpRef = React.createRef();
    // this.phoneOtpRef = React.createRef();
  }

  componentDidMount() {
    updateFavicon();
    localStorage.setItem("secondStatusCheckForTwoMinTimer", true);
    let count = "120";
    localStorage.setItem("cdfortwomin", count);
    this.onPageLoadTimer(120);

    if (localStorage.getItem("secondStatusCheckForTwoMinTimer") == "true") {
      this.onPageLoadTimer(localStorage.getItem("cdfortwomin"));
      this.setState({
        secondStatusCheckForTwoMinTimer: true,
        isTwoMinTimerStart: true,
        twoMinTimerTxt: localStorage.getItem("cdfortwomin"),
      });
    } else {
      this.setState({
        secondStatusCheckForTwoMinTimer: false,
      });
    }

    if (localStorage.getItem("secondStatusCheckForEmailOtp") == "true") {
      this.startTimerForEmailOtp(
        localStorage.getItem("countdownsecforemailotp")
      );
      this.setState({
        secondStatusCheckForEmailOtp: true,
        emailOtpTimer: localStorage.getItem("countdownsecforemailotp"),
      });
    } else {
      this.setState({
        secondStatusCheckForEmailOtp: false,
      });
    }

    if (localStorage.getItem("secondStatusCheckForPhoneOtp") == "true") {
      this.startTimerForPhoneOtp(
        localStorage.getItem("countdownsecforphoneotp")
      );
      this.setState({
        secondStatusCheckForPhoneOtp: true,
        resendPhoneOtpBtn: true,
        phoneOtpTimer: localStorage.getItem("countdownsecforphoneotp"),
      });
    } else {
      this.setState({
        secondStatusCheckForPhoneOtp: false,
      });
    }
  }

  handleOtpChange = (e) => {
    let elmVal = e.target.value;
    if (elmVal.length > 7) {
      elmVal = elmVal.slice(0, 7);
      e.target.value = elmVal;
    }
    let regex = /^[0-9]{7,7}$/;
    if (regex.test(elmVal)) {
      this.setState({
        verifySignUpBtn: false,
        isEmailOtpCorrect: true,
      });

      // Auto submit if this OTP hasn't been submitted yet
      if (elmVal !== this.state.lastSubmittedOtp && !this.state.showLoader) {
        this.setState({ lastSubmittedOtp: elmVal }, () => {
          this.userRegisteration();
        });
      }
    } else {
      this.setState({
        verifySignUpBtn: true,
        isEmailOtpCorrect: false,
      });
    }
  };

  userRegisteration = (e) => {
    if (e) e.preventDefault();
    if (
      this.emailOtpRef.current.value != "" &&
      this.state.isEmailOtpCorrect == true
    ) {
      this.setState({
        verifySignUpBtn: true, // Disable during submission
        showLoader: true,
      });
      let payload = {
        first_name: localStorage.getItem(SITENAMEALIAS + "_first_name"),
        last_name: localStorage.getItem(SITENAMEALIAS + "_last_name"),
        email: localStorage.getItem(SITENAMEALIAS + "_email"),
        password: localStorage.getItem(SITENAMEALIAS + "_password"),
        organization_name: localStorage.getItem(
          SITENAMEALIAS + "_organization_name"
        ),
        phone: localStorage.getItem(SITENAMEALIAS + "_phone_number"),
        countryCode: localStorage.getItem(SITENAMEALIAS + "_dialCode"),
        gender: localStorage.getItem(SITENAMEALIAS + "_gender"),
        country: localStorage.getItem(SITENAMEALIAS + "_country"),
        brokerId: localStorage.getItem(SITENAMEALIAS + "_brokerId"),
        referredBy: localStorage.getItem(SITENAMEALIAS + "_referredBy"),

        // phone_otp: this.phoneOtpRef.current.value,
        email_otp: this.emailOtpRef.current.value,
        temp_merchant_id: localStorage.getItem(
          SITENAMEALIAS + "_temp_merchant_id"
        ),
      };
      // if (
      //   localStorage.getItem(SITENAMEALIAS + "_brokerId") != undefined &&
      //   localStorage.getItem(SITENAMEALIAS + "_brokerId") != "undefined" &&
      //   localStorage.getItem(SITENAMEALIAS + "_brokerId") != "" &&
      //   localStorage.getItem(SITENAMEALIAS + "_brokerId") != null
      // ) {
      //   if (window.location.origin == "https://portal.paybito.com") {
      //     payload["brokerId"] = localStorage.getItem("DEMOBROKERID");
      //   } else {
      //     payload["brokerId"] = localStorage.getItem(
      //       SITENAMEALIAS + "_broker_id"
      //     );
      //   }
      // } else {
      //   payload["brokerId"] = localStorage.getItem(SITENAMEALIAS + "_brokerId");
      // }
      getRegister(payload)
        .then(
          function (res) {
            let response = res.data[0];
            if (response.error != "0") {
              console.log(response.error_msg);
              console.log(response.error);
              showToast("error", response.error_msg);
              localStorage.setItem("countdownsecforemailotp", "");
              localStorage.setItem("cdfortwomin", "");
              this.setState({ showLoader: false, verifySignUpBtn: false });
              // this.props.history.push("/");
            } else {
              console.log("response4545", response);
              showToast("success", response.error_msg);
              // this.props.history.push("/");

              const userData = response?.data;

              localStorage.setItem(
                SITENAMEALIAS + "_merchant_id",
                userData["merchant_id"]
              );
              localStorage.setItem(
                SITENAMEALIAS + "_merchant_uuid",
                userData["uuid"]
              );
              localStorage.setItem(
                SITENAMEALIAS + "_exchange_uuid",
                userData["exchangeUserUuid"]
              );
              localStorage.setItem(
                SITENAMEALIAS + "_first_name",
                userData["first_name"]
              );
              localStorage.setItem(
                SITENAMEALIAS + "_last_name",
                userData["last_name"]
              );
              localStorage.setItem(SITENAMEALIAS + "_email", userData["email"]);

              localStorage.setItem(
                SITENAMEALIAS + "_phoneno",
                userData["phone"]
              );
              localStorage.setItem(
                SITENAMEALIAS + "_email_confirmed",
                userData["email_confirmed"]
              );
              localStorage.setItem(
                SITENAMEALIAS + "_basic_verification_submitted",
                userData["basic_verification_submitted"]
              );
              localStorage.setItem(
                SITENAMEALIAS + "_crypto_address_added",
                userData["crypto_address_added"]
              );
              localStorage.setItem(
                SITENAMEALIAS + "_account_status_id",
                userData["account_status_id"]
              );

              let accessToken = userData.oauth2.access_token;
              let uuid = userData.uuid;
              localStorage.setItem(
                SITENAMEALIAS + "_access_token",
                accessToken
              );
              localStorage.setItem(SITENAMEALIAS + "_uuid", uuid);
              localStorage.setItem(
                SITENAMEALIAS + "_parent_merchant_id",
                userData["parent_merchant_id"]
              );
              localStorage.setItem(
                SITENAMEALIAS + "_broker_id",
                userData["brokerId"]
              );
              localStorage.setItem(
                SITENAMEALIAS + "_access_list",
                JSON.stringify(userData["access_list"])
              );
              localStorage.setItem(
                SITENAMEALIAS + "_country",
                userData["country"]
              );
              localStorage.setItem("cdforemail", "");
              localStorage.setItem(
                SITENAMEALIAS + "_created_on",
                userData["created_on"]
              );
              localStorage.removeItem(SITENAMEALIAS + "_referredBy");

              this.props.history.push("/get-started");
              setTimeout(() => {
                window.location.reload();
              }, 100);
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    } else {
      showToast("error", "Please provide valid details");
    }
  };

  startTimerForEmailOtp = (i) => {
    let count = i;
    this.setState({ emailOtpTimer: count }, () => {
      let downloadTimer = setInterval(() => {
        if (count <= 1) {
          clearInterval(downloadTimer);
          this.setState({
            secondStatusCheckForEmailOtp: false,
            isResendTimerStartForEmailOtp: false,
          });
          localStorage.setItem("secondStatusCheckForEmailOtp", "false");
          this.state.resendEmailOtpBtn = true;
        }
        count -= 1;
        localStorage.setItem("countdownsecforemailotp", count);
        this.setState({
          emailOtpTimer: localStorage.getItem("countdownsecforemailotp"),
        });
      }, 1000);
    });
  };

  onPageLoadTimer = (i) => {
    let count = i;
    this.setState({ twoMinTimerTxt: count }, () => {
      let downloadTimer = setInterval(() => {
        if (count <= 1) {
          clearInterval(downloadTimer);
          this.setState({
            secondStatusCheckForTwoMinTimer: false,
            resendEmailOtpBtn: true,
            resendPhoneOtpBtn: true,
          });
          localStorage.setItem("secondStatusCheckForTwoMinTimer", "false");
          this.state.isTwoMinTimerStart = false; //show on load otp timer
        }
        count -= 1;
        localStorage.setItem("cdfortwomin", count);
        this.setState({ twoMinTimerTxt: localStorage.getItem("cdfortwomin") });
      }, 1000);
    });
  };

  startTimerForPhoneOtp = (i) => {
    let count = i;
    this.setState({ phoneOtpTimer: count }, () => {
      let downloadTimer = setInterval(() => {
        if (count <= 1) {
          clearInterval(downloadTimer);
          this.setState({
            secondStatusCheckForPhoneOtp: false,
            isResendTimerStartForPhoneOtp: false,
          });
          localStorage.setItem("secondStatusCheckForPhoneOtp", "false");
          this.state.resendPhoneOtpBtn = true;
        }
        count -= 1;
        localStorage.setItem("countdownsecforphoneotp", count);
        this.setState({
          phoneOtpTimer: localStorage.getItem("countdownsecforphoneotp"),
        });
      }, 1000);
    });
  };

  resendEmailOtp = () => {
    this.sendEmailOtp();
    this.setState({
      secondStatusCheckForEmailOtp: true,
      resendEmailOtpBtn: false,
    });
    localStorage.setItem("secondStatusCheckForEmailOtp", "true");
    let count = "120";
    localStorage.setItem("countdownsecforemailotp", count);
    this.startTimerForEmailOtp(120);
  };

  resendPhoneOtp = () => {
    this.sendPhoneOtp();
    this.setState({
      secondStatusCheckForPhoneOtp: true,
      resendPhoneOtpBtn: false,
    });
    localStorage.setItem("secondStatusCheckForPhoneOtp", "true");
    let count = "120";
    localStorage.setItem("countdownsecforphoneotp", count);
    this.startTimerForPhoneOtp(120);
  };

  sendEmailOtp = () => {
    let payload = {
      email: localStorage.getItem(SITENAMEALIAS + "_email"),
      temp_merchant_id: localStorage.getItem(
        SITENAMEALIAS + "_temp_merchant_id"
      ),
    };
    getSignUpEmailOtp(payload)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", "Otp send to your given email");
            this.setState({
              isResendTimerStartForEmailOtp:
                !this.state.isResendTimerStartForEmailOtp,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          //console.log('3', err)
          showHttpError(err);
        }.bind(this)
      );
  };

  sendPhoneOtp = () => {
    let payload = {
      phone: localStorage.getItem(SITENAMEALIAS + "_phone_number"),
      temp_merchant_id: localStorage.getItem(
        SITENAMEALIAS + "_temp_merchant_id"
      ),
    };
    getSignUpPhoneOtp(payload)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", "Otp send to your phone number");
            this.setState({
              isResendTimerStartForPhoneOtp:
                !this.state.isResendTimerStartForPhoneOtp,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          //console.log('3', err)
          showHttpError(err);
        }.bind(this)
      );
  };

  render() {
    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{localStorage.getItem(SITENAMEALIAS + "_exchange")}</title>
        </Helmet>
        {localStorage.getItem(SITENAMEALIAS + "_isBackgroundImage") == "0" ? (
          <div
            className="login-wrapper"
            style={{
              background: localStorage.getItem(
                SITENAMEALIAS + "_backgroundColour"
              ),
            }}
          >
            <div className="pb-0 login-background">
              <div className="card form-card">
                <div className="card-body cardBody">
                  <h4 className="otp-page-title">OTP Verification</h4>
                  {/* <div className="otp-separator"></div> */}

                  <form
                    className="forms-sample"
                    onSubmit={(event) => {
                      this.userRegisteration(event);
                    }}
                  >
                    <div className="form-group">
                      <label className="otp-label" htmlFor="exampleInputEmail1">
                        Enter OTP send to registered email address
                      </label>
                      <input
                        type="text"
                        className="otp-input"
                        id="exampleInputEmail1"
                        ref={this.emailOtpRef}
                        // value={this.state.emailVerificationOtp}
                        placeholder="Enter OTP send to registered email address"
                        onChange={this.handleOtpChange}
                      />
                      {this.state.resendEmailOtpBtn && (
                        <small
                          className="otp-resend-link"
                          onClick={this.resendEmailOtp}
                        >
                          Resend OTP
                        </small>
                      )}
                    </div>

                    {this.state.isResendTimerStartForEmailOtp && (
                      <p className="otp-timer-text">
                        Resend Otp in {this.state.emailOtpTimer}
                      </p>
                    )}

                    {this.state.isTwoMinTimerStart && (
                      <p className="otp-timer-text">
                        Resend Otp in {this.state.twoMinTimerTxt}
                      </p>
                    )}

                    <p className="otp-note">
                      *One-time password sent to your email occasionally takes
                      longer to receive depending on email server rules.
                    </p>

                    <button
                      type="submit"
                      className="btn login-btn"
                      style={{
                        backgroundColor: localStorage.getItem(
                          SITENAMEALIAS + "_buttonColour"
                        ),
                        width: "100%",
                      }}
                      disabled={this.state.verifySignUpBtn}
                    >
                      {" "}
                      Submit{" "}
                    </button>
                  </form>
                </div>
              </div>
            </div>
            {window.location.origin == DEMOBROKER ? (
              <div className="d-flex align-items-end flex-column bd-highlight mb-3 footer-data">
                <a href="https://www.paybito.com/">
                  <div className="btn btn-light mt-auto p-2 bd-highlight footer-data-text">
                    <img
                      src={logo}
                      alt=""
                      style={{ marginRight: 3, height: "30px" }}
                    />
                    Powered by PayBito infrastructure
                  </div>
                </a>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        ) : (
          <div
            className="login-wrapper"
            style={{
              backgroundImage: `url(${localStorage.getItem(
                SITENAMEALIAS + "_backgroundImageLink"
              )})`,
              backgroundRepeat: `no-repeat`,
              backgroundSize: `cover`,
              backgroundPosition: `center`,
              minHeight: `100%`,
            }}
          >
            <div className="pb-0 login-background">
              <div className="card form-card">
                <div className="card-body cardBody">
                  <h4 className="otp-page-title">OTP Verification</h4>
                  <div className="otp-separator"></div>

                  <form
                    className="forms-sample"
                    onSubmit={(event) => {
                      this.userRegisteration(event);
                    }}
                  >
                    <div className="form-group">
                      <label className="otp-label" htmlFor="exampleInputEmail1">
                        Enter OTP send to registered email address
                      </label>
                      <input
                        type="text"
                        className="otp-input"
                        id="exampleInputEmail1"
                        ref={this.emailOtpRef}
                        // value={this.state.emailVerificationOtp}
                        placeholder="Enter OTP send to registered email address"
                        onChange={this.handleOtpChange}
                      />
                      {this.state.resendEmailOtpBtn && (
                        <small
                          className="otp-resend-link"
                          onClick={this.resendEmailOtp}
                        >
                          Resend OTP
                        </small>
                      )}
                    </div>

                    {this.state.isResendTimerStartForEmailOtp && (
                      <p className="otp-timer-text">
                        Resend Otp in {this.state.emailOtpTimer}
                      </p>
                    )}

                    {this.state.isTwoMinTimerStart && (
                      <p className="otp-timer-text">
                        Resend Otp in {this.state.twoMinTimerTxt}
                      </p>
                    )}

                    <p className="otp-note">
                      *One-time password sent to your email occasionally takes
                      longer to receive depending on email server rules.
                    </p>

                    <button
                      type="submit"
                      className="btn login-btn"
                      style={{
                        backgroundColor: localStorage.getItem(
                          SITENAMEALIAS + "_buttonColour"
                        ),
                        width: "100%",
                      }}
                      disabled={this.state.verifySignUpBtn}
                    >
                      {" "}
                      Submit{" "}
                    </button>
                  </form>
                </div>
              </div>
            </div>
            {window.location.origin == DEMOBROKER ? (
              <div className="d-flex align-items-end flex-column bd-highlight mb-3 footer-data">
                <a href="https://www.paybito.com/">
                  <div className="btn btn-light mt-auto p-2 bd-highlight footer-data-text">
                    <img
                      src={logo}
                      alt=""
                      style={{ marginRight: 3, height: "30px" }}
                    />
                    Powered by PayBito infrastructure
                  </div>
                </a>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        )}

        <Loader show={this.state.showLoader} />
      </Fragment>
    );
  }
  componentWillMount() {}
}
export default withRouter(Otp);
